import { isAfter, isSameDay, isWeekend } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker, FormError, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { RollRiskSchemaType } from '@/components/forms/RollRiskForm/RollRiskForm'

export interface RollRiskFormFieldsProps {
  inputsDisabled?: boolean
}

export const RollRiskFormFields: React.FC<RollRiskFormFieldsProps> = ({ inputsDisabled }) => {
  const { control, setValue } = useFormContext<RollRiskSchemaType>()
  const date_t = useWatch<RollRiskSchemaType>({ control, name: 'date_t' })

  return (
    <div className={'@container'}>
      <div className="flex items-center gap-4">
        <FormField
          name="date_t"
          control={control}
          render={({ field: { value } }) => {
            return (
              <FormItem>
                <div className="flex items-center gap-2">
                  <FormLabel>Date T</FormLabel>
                  <FormError />
                </div>
                <DatePicker
                  selected={value ? new Date(value) : undefined}
                  disabled={(date) => isWeekend(date) || isAfter(date, new Date())}
                  buttonDisabled={inputsDisabled}
                  onSelect={(date) =>
                    date ? setValue('date_t', toISO8601(date), { shouldValidate: true }) : undefined
                  }
                />
              </FormItem>
            )
          }}
        />
        <FormField
          name="date_tmo"
          control={control}
          render={({ field: { value } }) => {
            return (
              <FormItem>
                <div className="flex items-center gap-2">
                  <FormLabel>Date T-1</FormLabel>
                  <FormError />
                </div>
                <DatePicker
                  selected={value ? new Date(value) : undefined}
                  buttonDisabled={!date_t || inputsDisabled}
                  disabled={(date) =>
                    isWeekend(date) ||
                    (date_t
                      ? isAfter(date, new Date(date_t)) || isSameDay(date, new Date(date_t))
                      : false)
                  }
                  onSelect={(date) =>
                    date
                      ? setValue('date_tmo', toISO8601(date), { shouldValidate: true })
                      : undefined
                  }
                />
              </FormItem>
            )
          }}
        />
      </div>
    </div>
  )
}
